import { css, keyframes } from '@emotion/css';

export const load8 = keyframes`
   0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

export const loader = ({ size, variant }) => css`
  width: ${size || '64px'};
  height: ${size || '64px'};
  border-radius: 50%;

  ${variant === 'primary' && `
    border-top: 1.5px solid rgba(58, 131, 249, 0.2);
    border-right: 1.5px solid rgba(58, 131, 249, 0.2);
    border-bottom: 1.5px solid rgba(58, 131, 249, 0.2);
    border-left: 1.5px solid #3A83F9;
  `}

  ${variant === 'white' && `
    border-top: 1.5px solid rgba(255, 255, 255, 0.2);
    border-right: 1.5px solid rgba(255, 255, 255, 0.2);
    border-bottom: 1.5px solid rgba(255, 255, 255, 0.2);
    border-left: 1.5px solid #FFFFFF;
  `}

  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: ${load8} 1.1s infinite linear;
  animation: ${load8} 1.1s infinite linear;
`;
